var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-drawer",class:{ 'is-detailed': _vm.isDetailedView }},[(!_vm.isDetailedView)?_c('QuickMoveInListGrid'):_vm._e(),(_vm.isDetailedView)?_c('QuickMoveInListDetail'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }